// extracted by mini-css-extract-plugin
export default {"root":"lMm3Q","placeholder":"lcu0T"};